import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { HeaderTitle } from 'components/UserProfile';
import useUserStore from 'store/user';
import useTranslate from 'hooks/useTranslate';
import { S3_URL, USER_TYPES } from 'constants';
import useAuthStore from 'store/auth';
import './styles.scss';

const ResumeBox: React.FC<any> = ({ onShowModal, isSelf, handleDeleteResume, type }: any) => {
	const { translate } = useTranslate();
	const { profileData: { resume = {} } = {} }: any = useUserStore((state) => state);
	const { user: authUser }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});
	const handleDownload = async (evt: any) => {
		evt.stopPropagation();

		if (resume?.path) {
			try {
				// Validate the file path to ensure it's safe (basic validation for demonstration)
				const safePath = resume.path.replace(/[^a-zA-Z0-9-_/\.]/g, '');

				const response = await fetch(`${S3_URL}${safePath}`);
				if (!response.ok) {
					throw new Error('Failed to fetch PDF file');
				}

				const blob = await response.blob();
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', safePath.split('/').pop() || 'file.pdf');
				link.style.display = 'none';

				// Ensure safe appending and removal
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);

				// Revoke the object URL to release memory
				window.URL.revokeObjectURL(url);
			} catch (error) {
				console.error('Error downloading PDF:', error);
			}
		}
	};

	return (
		<div className="video-resume-box white-box bg-white">
			<HeaderTitle title={translate('Profile.resume')} onShowModal={onShowModal} />
			<div className="video-resume-box-inner">
				<div className="video-resume-box-inner-preview d-flex align-items-center justify-content-between gap-2">
					<h4 className="mb-0 d-flex gap-2 video-resume-box-inner-title align-items-center">
						<Link to="">
							<i className="ri-attachment-2"></i>
						</Link>
						{resume?.title ?? translate('Profile.resume')}
						{resume?.path && (isSelf || authUser?.userType === USER_TYPES?.COMPANY) && (
							<Button className="edit-btn rounded-circle p-0 border-0" onClick={handleDownload}>
								<i className="ri-download-line"></i>
							</Button>
						)}
					</h4>

					{isSelf && (
						<div className="d-flex gap-2 gap-sm-3">
							<Button
								className="edit-btn rounded-circle p-0 border-0"
								onClick={() => onShowModal('editResume')}
							>
								<i className="ri-eye-line"></i>
							</Button>
							{resume?.path && (isSelf || authUser?.userType === USER_TYPES?.COMPANY) && (
								<Button
									className="edit-btn rounded-circle p-0 border-0"
									onClick={() => handleDeleteResume(type)}
								>
									<i className="ri-delete-bin-line"></i>
								</Button>
							)}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default ResumeBox;
